export enum MembershipTier {
  MEMBERSHIPTIER1 = 'membershiptier1',
  MEMBERSHIPTIER2 = 'membershiptier2',
  MEMBERSHIPTIER3 = 'membershiptier3',
  MEMBERSHIPTIER4 = 'membershiptier4',
  MEMBERSHIPTIER5 = 'membershiptier5',
}
